export default __webpack_public_path__ + "static/media/lawn-care.6d6b8f62.jpg";